// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductSort_root__2Wxu8","select":"ProductSort_select__-YFCg"};